module.exports = __webpack_public_path__ + "static/media/apps-purple.d2349ab5.svg";